export default __webpack_public_path__ + "static/media/emoji_sadness.d4063bc8.png";